import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { Modal } from 'sa-ui';

import messages from './simulatedCorrectionTermsOfUseModalMessages';

export function getTermsContent(intl) {
  switch (intl.locale.toUpperCase()) {
    case 'PT':
      return `
            <div class="text-left">
                <p><span class="text-warning">Importante! </span>Para que o processo de correção dos cartões resposta ocorra sem problemas, estou ciente que:</p>
                <p><strong>1. A impressão dos cartões resposta devem seguir as configurações abaixo:</strong></p>
                <ul>
                    <li>Cor da impressão: Preto e Branco</li>
                    <li>Modo da impressão: Laser e normal (NUNCA modo rascunho)</li>
                    <li>Papel: branco e no tamanho A4;</li>
                    <li>Por favor, imprimir apenas uma ficha por folha (NUNCA use frente e verso)</li>
                </ul>
                <p><strong>2. A digitalização dos cartões-resposta devem seguir as configurações abaixo:</strong></p>
                <ul>
                    <li>Resolução mínima: 300 dpi e em escala de cinza</li>
                    <li>Posição: vertical</li>
                    <li>Tipo de arquivo: .JPEG ou .PNG</li>
                    <li>Todas as imagens devem estar alinhadas e com o cabeçalho para cima</li>
                    <li>Cada arquivo deve conter apenas um cartão-resposta</li>
                    <li>Fichas em branco NÃO devem ser enviadas</li>
                </ul>
                <p>Os arquivos que NÃO seguirem os padrões estabelecidos acima não serão corrigidos e deverão ser validados pela própria escola no ambiente de ”Auditoria” localizado no card do seu respectivo simulado.</p>
            </div>`;
    default:
      return `
            <div class="text-left">
                <p><span class="text-warning">Importante! </span>Para que o processo de correção dos cartões resposta ocorra sem problemas, estou ciente que:</p>
                <p><strong>1. A impressão dos cartões resposta devem seguir as configurações abaixo:</strong></p>
                <ul>
                    <li>Cor da impressão: Preto e Branco</li>
                    <li>Modo da impressão: Laser e normal (NUNCA modo rascunho)</li>
                    <li>Papel: branco e no tamanho A4;</li>
                    <li>Por favor, imprimir apenas uma ficha por folha (NUNCA use frente e verso)</li>
                </ul>
                <p><strong>2. A digitalização dos cartões-resposta devem seguir as configurações abaixo:</strong></p>
                <ul>
                    <li>Resolução mínima: 300 dpi e em escala de cinza</li>
                    <li>Posição: vertical</li>
                    <li>Tipo de arquivo: .JPEG ou .PNG</li>
                    <li>Todas as imagens devem estar alinhadas e com o cabeçalho para cima</li>
                    <li>Cada arquivo deve conter apenas um cartão-resposta</li>
                    <li>Fichas em branco NÃO devem ser enviadas</li>
                </ul>
                <p>Os arquivos que NÃO seguirem os padrões estabelecidos acima não serão corrigidos e deverão ser validados pela própria escola no ambiente de ”Auditoria” localizado no card do seu respectivo simulado.</p>
            </div>
        `;
  }
}

function SimulatedCorrectionTermsOfUseModal(props) {
  const closeButton = {
    label: props.intl.formatMessage(messages.back),
    onClick: props.onClose,
  };
  const manuallyLoadButton = {
    label: props.intl.formatMessage(messages.manuallyLoad),
    onClick: props.onManuallyLoad,
  };
  const continueButton = {
    label: props.intl.formatMessage(messages.agreeAndContinue),
    onClick: props.onContinue,
    primary: true,
  };
  const buttons = props.manual
    ? [manuallyLoadButton, continueButton]
    : [closeButton, continueButton];
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="icon ti-marker-alt"
      title={props.intl.formatMessage(messages.title)}
      buttons={buttons}
    >
      <div className="text-left" dangerouslySetInnerHTML={{ __html: getTermsContent(props.intl) }} />
    </Modal>
  );
}

export default injectIntl(SimulatedCorrectionTermsOfUseModal);
